"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Form_1 = __importDefault(require("react-bootstrap/Form"));
const react_bootstrap_1 = require("react-bootstrap");
const react_select_1 = __importDefault(require("react-select"));
const customStyles = {
    control: (provided, state) => ({
        ...provided,
        borderColor: state.isFocused ? '#0C93A9' : provided.borderColor,
        boxShadow: state.isFocused ? `0 0 0 2px #0C93A9` : provided.boxShadow, // Ombra quando selezionato
    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isFocused ? '#EEF4F5' : provided.backgroundColor,
        color: state.isFocused ? '#0C93A9' : provided.color,
        '&:hover': {
            backgroundColor: '#EEF4F5',
            color: '#0C93A9',
        },
        zIndex: 20000000,
        ...(state.isSelected && { backgroundColor: '#0C93A9', color: 'white' }), // Aggiungi questa regola per l'opzione attiva selezionata
    }),
};
function FormSelect(props) {
    const { isMulti, value, formik, name, options, placeholder, disabled, label, note, onChange } = props;
    const optionForSelect = options.map((item) => ({
        value: item.id,
        label: item.description
    }));
    const valueOption = optionForSelect.filter(opt => opt.value === value)[0];
    const onChangeSelected = (change) => {
        if (formik) {
            formik.setFieldValue(name, change);
        }
    };
    return (react_1.default.createElement(react_bootstrap_1.FormGroup, { className: "label-select", style: { marginTop: '3px' } },
        react_1.default.createElement(Form_1.default.Label, { className: "label" }, label),
        react_1.default.createElement(react_select_1.default, { styles: customStyles, options: optionForSelect, name: name, placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : '-', onChange: onChange ? onChange : onChangeSelected, value: valueOption, isMulti: isMulti, isDisabled: disabled, className: "br-10" }),
        note ? react_1.default.createElement(Form_1.default.Text, { muted: true }, note) : null,
        props.html ? react_1.default.createElement("div", { dangerouslySetInnerHTML: { __html: props.html } }) : null));
}
exports.default = FormSelect;
